import template from "./message-bubble.html";
import "./message-bubble.less";

export class MessageBubble {
	constructor(uiHelpers) {
		this.uiHelpers = uiHelpers;
	}

	$onInit() {
		this.contact = this.message.contact;
		this.buildAvatarColors();
	}

	getInitials() {
		return `${this.contact.firstName.substring(0, 1)}${this.contact.lastName.substring(0, 1)}`;
	}

	buildAvatarColors() {
		const bkColor = this.uiHelpers.stringToHexColour(`${this.contact.firstName}${this.contact.lastName}`);

		this.avatarBkColor = this.uiHelpers.intToHexColorString(bkColor);
		this.avatarTextColor = this.uiHelpers.textColorForHexBk(bkColor);
	}

	getAllMembers() {
		return this.nonThisParticipants.map((item) => `${item.firstName} ${item.lastName}`).reduce((prev, curr) => { return `${prev}, ${curr}`; });
	}
}

export default angular
	.module("vesl.components.message-bubble", [])
	.component("messageBubble", {
		template,
		controller: MessageBubble,
		bindings: {
			message: "<",
			alignRight: "<"
		}
	}).name;
